export default "/packs/images/woman-boxing~7d2f87974069443f91c62a03caeea27d.jpg";